import { api } from "./configs/axiosConfigs"

export const ProductAttributeAPI = {
    
    getproductAttribute: async (data:any) => {
        const response = await api.get(
            '/productattribute', { params: {...data} }
        ).then(response => response.data)
        .catch((error) => {
            return error.response.data
        })
        return response
    },

    getproductAttributeByCompany: async (data:any) => {
        const response = await api.get(
            '/productattribute/listByCompany', { params: {...data} }
        ).then(response => response.data)
        .catch((error) => {
            return error.response.data
        })
        return response
    },

    createproductAttribute: async (data: any) => {
        const response = await api.post(
            '/productattribute/register', data
        ).then(response => response.data)
        .catch((error) => {
            console.error(error)
            return error.response.data
        })
        return response
    },

    optimizatedproductAttribute: async (data: any) => {
        const response = await api.post(
            '/productattribute/dataOptimizated', data
        ).then(response => response.data)
        .catch((error) => {
            console.error(error)
            return error.response.data
        })
        return response
    },
    
    editproductAttribute: async (idattribute: number, data: any) => {
        const response = await api.patch(
            `/productattribute/${idattribute}`, data
        ).then(response => response.data)
        .catch((error) => {
            return error.response.data
        })
        return response
    },

    changeStatusproductAttribute: async (idattribute: number, data: any) => {
        const response = await api.patch(
            `/productattribute/changeStatus/${idattribute}`, data
        ).then(response => response.data)
        .catch((error) => {
            return error.response.data
        })
        return response
    },
    
    deleteproductAttribute: async (idattribute: number) => {
        const response = await api.delete(
            `/productattribute/${idattribute}`
        ).then(response => response.data)
        .catch((error) => {
            return error.response.data
        })
        return response
    },
}